(function () {
  var STORAGE_KEY = 'alboushiya_wishlist_v1';
  var drawer = document.getElementById('wishlist-drawer');
  if (!drawer) return;

  var root = document.getElementById('wishlist-drawer-root');
  var currency = drawer.dataset.currency || 'AED';
  var strings = {
    title: drawer.dataset.title || 'Wishlist',
    empty: drawer.dataset.empty || 'Your wishlist is empty',
    continue: drawer.dataset.continue || 'Continue shopping',
    addCart: drawer.dataset.addCart || 'Add to bag',
    remove: drawer.dataset.remove || 'Remove',
  };

  var ICONS = {
    close:
      '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
  };

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    syncUi(list);
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: list } }));
  }

  function formatMoney(cents) {
    if (window.AlboushiyaCurrency && typeof window.AlboushiyaCurrency.formatFromAedCents === 'function') {
      return window.AlboushiyaCurrency.formatFromAedCents(cents);
    }
    var amount = (Number(cents || 0) / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return currency + ' ' + amount;
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function findIndex(list, handle) {
    return list.findIndex(function (item) {
      return item.handle === handle;
    });
  }

  function syncUi(list) {
    var handles = {};
    list.forEach(function (item) {
      handles[item.handle] = true;
    });

    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      var active = !!(handle && handles[handle]);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      var count = list.length;
      el.textContent = String(count);
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function upsertFromButton(btn) {
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    var list = read();
    var idx = findIndex(list, handle);
    if (idx >= 0) {
      list.splice(idx, 1);
      write(list);
      return;
    }

    var item = {
      handle: handle,
      id: btn.getAttribute('data-product-id') || '',
      variantId: btn.getAttribute('data-variant-id') || '',
      title: btn.getAttribute('data-product-title') || handle,
      url: btn.getAttribute('data-product-url') || ('/products/' + handle),
      image: btn.getAttribute('data-product-image') || '',
      price: parseInt(btn.getAttribute('data-product-price') || '0', 10),
      available: btn.getAttribute('data-product-available') !== 'false',
    };
    list.unshift(item);
    write(list);
  }

  function removeHandle(handle) {
    var list = read().filter(function (item) {
      return item.handle !== handle;
    });
    write(list);
  }

  function render() {
    if (!root) return;
    var list = read();

    var body;
    if (!list.length) {
      body =
        '<div class="wishlist-drawer__empty"><p>' +
        escapeHtml(strings.empty) +
        '</p><a href="/" data-wishlist-drawer-close>' +
        escapeHtml(strings.continue) +
        '</a></div>';
    } else {
      body =
        '<div class="wishlist-drawer__items">' +
        list
          .map(function (item) {
            var img = item.image
              ? '<img class="wishlist-drawer__item-image" src="' +
                escapeHtml(item.image) +
                '" alt="' +
                escapeHtml(item.title) +
                '" width="88" height="132" loading="lazy">'
              : '<div class="wishlist-drawer__item-image wishlist-drawer__item-image--placeholder"></div>';
            return (
              '<div class="wishlist-drawer__item" data-handle="' +
              escapeHtml(item.handle) +
              '">' +
              '<a href="' +
              escapeHtml(item.url) +
              '">' +
              img +
              '</a>' +
              '<div class="wishlist-drawer__item-meta">' +
              '<a class="wishlist-drawer__item-title" href="' +
              escapeHtml(item.url) +
              '">' +
              escapeHtml(item.title) +
              '</a>' +
              '<p class="wishlist-drawer__item-price">' +
              formatMoney(item.price) +
              '</p>' +
              '<div class="wishlist-drawer__item-actions">' +
              '<button type="button" class="wishlist-drawer__item-btn wishlist-drawer__item-btn--primary" data-wishlist-add-cart="' +
              escapeHtml(item.variantId) +
              '" data-handle="' +
              escapeHtml(item.handle) +
              '"' +
              (!item.variantId || item.available === false ? ' disabled' : '') +
              '>' +
              escapeHtml(strings.addCart) +
              '</button>' +
              '<button type="button" class="wishlist-drawer__item-btn" data-wishlist-remove="' +
              escapeHtml(item.handle) +
              '">' +
              escapeHtml(strings.remove) +
              '</button>' +
              '</div></div></div>'
            );
          })
          .join('') +
        '</div>';
    }

    root.innerHTML =
      '<div class="wishlist-drawer__header">' +
      '<h2 class="wishlist-drawer__title" id="wishlist-drawer-title">' +
      escapeHtml(strings.title) +
      ' (' +
      list.length +
      ')</h2>' +
      '<button type="button" class="wishlist-drawer__close" data-wishlist-drawer-close aria-label="Close">' +
      ICONS.close +
      '</button></div>' +
      '<div class="wishlist-drawer__body">' +
      body +
      '</div>' +
      (list.length
        ? '<div class="wishlist-drawer__footer"><a href="/" class="wishlist-drawer__continue" data-wishlist-drawer-close>' +
          escapeHtml(strings.continue) +
          '</a></div>'
        : '');

    bindDrawerEvents();
    syncUi(list);
  }

  function bindDrawerEvents() {
    root.querySelectorAll('[data-wishlist-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    root.querySelectorAll('[data-wishlist-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeHandle(btn.getAttribute('data-wishlist-remove'));
        render();
      });
    });

    root.querySelectorAll('[data-wishlist-add-cart]').forEach(function (btn) {
      btn.addEventListener('click', async function () {
        var variantId = parseInt(btn.getAttribute('data-wishlist-add-cart'), 10);
        if (!variantId) return;
        btn.disabled = true;
        try {
          if (window.CartDrawer && window.CartDrawer.addToCart) {
            await window.CartDrawer.addToCart([{ id: variantId, quantity: 1 }]);
            close();
            window.CartDrawer.open();
          } else {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: 1 }),
            });
            window.location.href = '/cart';
          }
        } catch (e) {
          btn.disabled = false;
        }
      });
    });
  }

  function open() {
    render();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wishlist-drawer-open');
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('wishlist-drawer-open');
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      upsertFromButton(toggle);
      return;
    }

    var openBtn = e.target.closest('[data-wishlist-drawer-toggle]');
    if (openBtn) {
      e.preventDefault();
      open();
    }
  });

  var overlay = drawer.querySelector('.wishlist-drawer__overlay');
  if (overlay) overlay.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  syncUi(read());

  window.WishlistDrawer = {
    open: open,
    close: close,
    read: read,
    has: function (handle) {
      return findIndex(read(), handle) >= 0;
    },
    toggle: function (itemOrBtn) {
      if (itemOrBtn && itemOrBtn.getAttribute) upsertFromButton(itemOrBtn);
    },
  };
})();
